import { render, staticRenderFns } from "./CompletionRateChart.vue?vue&type=template&id=56b24250&scoped=true&"
import script from "./CompletionRateChart.vue?vue&type=script&lang=js&"
export * from "./CompletionRateChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b24250",
  null
  
)

export default component.exports